import { defineMessages } from "react-intl";

export const messages = defineMessages({
  titleLabel: {
    id: "previewSpeakerCard.title.label",
    defaultMessage: "Speaker",
    description: "Title label in preview room",
  },
  content: {
    id: "previewSpeakerCard.content.text",
    defaultMessage:
      "Test your speaker. You can adjust the volume using the buttons on your device. Click Play to start playback. To change the audio output device, please use your device’s system settings.",
    description: "Content text",
  },
  playButtonLabel: {
    id: "previewSpeakerCard.button.play.label",
    defaultMessage: "Play",
    description: "Label play button",
  },
  stopButtonLabel: {
    id: "previewSpeakerCard.button.stop.label",
    defaultMessage: "Stop",
    description: "Label stop button",
  },
});
